// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetPaymentProcessorData } from './GetPaymentProcessorData';
import {
  GetPaymentProcessorDataFromJSON,
  GetPaymentProcessorDataFromJSONTyped,
  GetPaymentProcessorDataToJSON,
  GetPaymentProcessorDataToJSONTyped,
} from './GetPaymentProcessorData';

/**
 *
 * @export
 * @interface GetPaymentProcessor
 */
export interface GetPaymentProcessor {
  /**
   * Unique identifier of the payment processor.
   * @type {string}
   * @memberof GetPaymentProcessor
   */
  paymentProcessorID: string;
  /**
   * Payment processor type (e.g., Stripe).
   * @type {string}
   * @memberof GetPaymentProcessor
   */
  type: string;
  /**
   *
   * @type {GetPaymentProcessorData}
   * @memberof GetPaymentProcessor
   */
  data?: GetPaymentProcessorData;
}

/**
 * Check if a given object implements the GetPaymentProcessor interface.
 */
export function instanceOfGetPaymentProcessor(
  value: object,
): value is GetPaymentProcessor {
  if (
    !('paymentProcessorID' in value) ||
    value['paymentProcessorID'] === undefined
  )
    return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function GetPaymentProcessorFromJSON(json: any): GetPaymentProcessor {
  return GetPaymentProcessorFromJSONTyped(json, false);
}

export function GetPaymentProcessorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetPaymentProcessor {
  if (json == null) {
    return json;
  }
  return {
    paymentProcessorID: json['paymentProcessorID'],
    type: json['type'],
    data:
      json['data'] == null
        ? undefined
        : GetPaymentProcessorDataFromJSON(json['data']),
  };
}

export function GetPaymentProcessorToJSON(json: any): GetPaymentProcessor {
  return GetPaymentProcessorToJSONTyped(json, false);
}

export function GetPaymentProcessorToJSONTyped(
  value?: GetPaymentProcessor | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    paymentProcessorID: value['paymentProcessorID'],
    type: value['type'],
    data: GetPaymentProcessorDataToJSON(value['data']),
  };
}
